import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_SSO_CLIENT_ID}`, // Mandatory field
    authority: `${process.env.REACT_APP_SSO_Authorities}`, // Replace with your tenant and user flow
    knownAuthorities: [`${process.env.REACT_APP_SSO_kNOWN_Authorities}`], // Replace with your B2C domain
    redirectUri: window.location.origin, // Must be registered in Azure Portal
    postLogoutRedirectUri: window.location.origin, // Page to navigate after logout
  },
  cache: {
    cacheLocation: 'localStorage', // Cache location ('sessionStorage' or 'localStorage')
    storeAuthStateInCookie: true, // Set true for IE 11 support
  },
};

const loginRequest = {
  scopes: ['api://e438e517-dbd1-4e8e-a01b-df08540c0276/access_as_user'],
};

const msalInstance = new PublicClientApplication(msalConfig);

// Function to get an access token
export const getToken = async () => {
  const accounts = msalInstance.getAllAccounts();
  console.log(accounts)
  if (accounts.length > 0) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        account: accounts[0],
        scopes: loginRequest.scopes,
      });
      return response.accessToken;
    } catch (error) {
      console.error('Silent token acquisition failed, falling back to interactive login.', error);
      if (error instanceof InteractionRequiredAuthError) {
        try {
          const response = await msalInstance.acquireTokenPopup({
            scopes: loginRequest.scopes,
          });
          return response.accessToken;
        } catch (interactiveError) {
          console.error('Interactive token acquisition failed.', interactiveError);
          throw interactiveError;
        }
      } else {
        throw error;
      }
    }
  } else {
    console.error('No accounts found. User needs to sign in.');
    throw new Error('No accounts found.');
  }
};

// Initialize MSAL instance (if required)
await msalInstance.initialize();

export { loginRequest, msalInstance };
